import utils from '../common/util';
import * as cmpDataContainer from './cmp-data-container';
import * as countdownTimer from "./cmp-countdown-timer"
import * as cmpLogResultsBtn from "./cmp-log-results-btn"
import * as cmpCountdownTimer from "./cmp-countdown-timer";
import * as cmpFlashScreen from "./cmp-flash-screen";
import * as cmpQuestionContainer from "./cmp-question-container";
import * as cmpPlayerNameContainer from "./cmp-player-name-container";

const cmpTruthDareBtn = {
    component: null,

    /**
     * Initialise the Truth and Dare Buttons
     * @param element
     */
    init: function (element)
    {
        utils.log('cmpTruthDareBtn initiated : #' + element.id, 'info');

        const _ = utils.setEnvironment(this);
        _.animatingTruthDareBtns = false;

        _.onClickEvent(element);
    },

    /**
     * Set on click events for each button
     */
    onClickEvent: function (element)
    {
        const _ = this;

        element.addEventListener('click', () =>
        {
            utils.log(element.id + ' button clicked', 'info');

            _.animatingTruthDareBtns = true;

            // collect variables from the data container object and clicked button
            Object.assign(_, cmpDataContainer.default.collectVariables());
            _.playType = element.getAttribute('data-play-type');

            _.getRemotePlayDetails();
            _.removeTruthDareButtons();
        })
    },

    /**
     * Slide the Truth and Dare buttons off the screen, then hide them, so they don't take up any space
     */
    removeTruthDareButtons: function ()
    {
        const _ = this;
        _.animatingTruthDareBtns = true;

        cmpPlayerNameContainer.default.hideDescription();

        for (const btn of _.truthDareBtns) {
            utils.oneTimeListener(btn, 'transitionend', (e) =>
            {
                if (['margin-left', 'opacity', 'margin-right'].indexOf(e.propertyName) === -1) return;
                utils.showHideElement(e.target, 'hide');
                _.animatingTruthDareBtns = false;
            });
            if (btn.classList.contains('random-btn')) {
                btn.classList.add('fade-out');
            } else {
                btn.classList.add('slide-out');
            }
        }
    },

    /**
     * Slide the Truth and Dare buttons back onto the screen
     */
    showTruthDareButtons: function (runTransitionEnd = true)
    {
        const _ = this;
        _.animatingTruthDareBtns = true;

        for (const btn of _.truthDareBtns) {
            utils.oneTimeListener(btn, 'transitionend', (e) =>
            {
                if (e.propertyName !== 'margin-left') return;

                _.animatingTruthDareBtns = false;
            });

	        utils.animateAndShow(btn, ['slide-out', 'fade-out']);
        }
    },

    /**
     * Use the API to get details of the next play
     */
    getRemotePlayDetails: function ()
    {
        const _ = this;

		if(['Truth', 'Random'].includes(_.playType))
		{
			cmpLogResultsBtn.default.hideButton('opponent-failed-btn');
		}

        fetch(utils.getApiUrl() + '/plays-random?' + new URLSearchParams({
            gender: _.genderTarget,
            gameLevelId: _.gameLevelId,
            playType: _.playType,
            gameId: _.gameId,
            playerId: _.currentPlayerId,
        }), {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + _.bearerToken
            },
        })
            .then(response => response.json())
            .then(data =>
                {
                    /** @namespace data.timer **/
                    /** @namespace data.score **/
                    /** @namespace data.gameLevelName **/
                    /** @namespace data.gameLevelNumber **/
                    // what happens if we are out of plays
                    if (data.status && data.status === 'out of plays') {
                        cmpFlashScreen.default.showLevelUpScreen(data);

                        utils.setVariables(_);

                        // update data properties on the data container
                        cmpDataContainer.default.setData({ 'data-game-level-id': data.gameLevelId });

                    } else {
                        // Wait until the Truth and Dare buttons have finished animating before continuing
                        let timer = setInterval(() =>
                        {
                            if (_.animatingTruthDareBtns === false) {
                                clearInterval(timer);

                                // add the play id and play timer to the data container so the results log button can use it
                                cmpDataContainer.default.setData(
                                    {
                                        'data-play-id': data.data.id,
                                        'data-countdown-from': data.data.timer,
                                        'data-play-score': data.data.score || "1",
                                    }
                                );

                                // add the question and timer to their containers
                                countdownTimer.default.setCountdownClock(data.data.timer);

                                // add the question to the question container and show it
                                cmpQuestionContainer.default.setQuestionText(data.data.title, data.data.action);
                                cmpQuestionContainer.default.showQuestionContainer();

                                // show the 'start timer' button if we have a timer
                                if (data.data.timer > 0) {
                                    cmpCountdownTimer.default.showCountdownTimer();
                                }

                                // otherwise, show the 'log results' buttons
                                else {
                                    cmpLogResultsBtn.default.showLogResultsButtons();
                                }
                            }
                        }, 10);
                    }
                }
            )
    }
}

export default cmpTruthDareBtn;
